export default __webpack_public_path__ + "static/media/blog_banner.b3df2e66.png";